<template>
  <div class="bundle-customiser__collection">
    <h3 class="bundle-customiser__collection-title product__label">
      <span class="index">{{ index + 1 }}</span>
      {{ dropdownTitle }}:
      <template v-if="collection.minimumQuantity > 1 && !isCollectionBundle">
        ({{ collection.selectedProducts.length }} selected)
      </template>
    </h3>
    <button
      :disabled="noProductsAvailable"
      :class="{disabled: noProductsAvailable}"
      class="bundle-customiser__collection-trigger variant-collection-dropdown-proxy sm flex justify-between items-center bg-white border-2 border-black hover:border-red"
      @click="openSlideout(index)"
    >
      <img
        v-if="productForImage"
        :src="productForImage?.image || productForImage?.images?.[0]"
        width="24"
        height="24"
      >
      <span v-if="showListOfSelectedProducts">
        <template
          v-for="(product, i) in collection.selectedProducts"
          :key="product.variantId || product.variants[0].id"
        >
          {{ i > 0 ? `, ${getProductTitle(product.title)}` : getProductTitle(product.title) }}
        </template>
      </span>
      <template v-else>
        {{ emptyOptionText }}
      </template>
      <ChevronRightIcon />
    </button>
  </div>
</template>

<script>
import {mapActions} from 'pinia'
import {useBundleStore} from '../pinia/BundleStore'

import ChevronRightIcon from '../icons/chevron-right'

export default {
  components: {
    ChevronRightIcon
  },
  props: {
    collection: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isCollectionBundle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dropdownTitle() {
      return this.collection.label.replace('[INDEX]', this.index + 1).replace('1', '1st').replace('2', '2nd').replace('3', '3rd')
    },
    showListOfSelectedProducts() {
      return !this.isCollectionBundle && this.collection.selectedProducts.length > 1
    },
    selectedProduct() {
      return this.isCollectionBundle ? this.collection.selectedProducts[this.index] : this.collection.selectedProducts[0]
    },
    hasNoProductsSelected() {
      return this.collection.selectedProducts.length === 0
    },
    productForImage() {
      return !this.hasNoProductsSelected ? this.selectedProduct : this.collection.initialProducts[0]
    },
    noProductsAvailable() {
      return !this.collection.initialProducts?.length
    },
    emptyOptionText() {
      return this.noProductsAvailable ? 'No products available' : (this.hasNoProductsSelected ? 'Select' :this. selectedProduct.title.toLowerCase())
    }
  },
  methods: {
    ...mapActions(useBundleStore, [
      'openSlideout',
    ]),
    getProductTitle(title) {
      return title.toLowerCase().includes('5 x') ? `5 X ${title.toLowerCase().replace(' (5 x 10g)', '')}` : title.toLowerCase()
    }
  }
}
</script>
